import React, { useContext, useState } from "react";
import { useAlert } from "../../../Context/AlertContext";
import styles from "./styles/Authenticator.module.css"
import QRCode from "react-qr-code";
import { UserData } from "../../../Context/DataContext";
import { useEffect } from "react";
import config from "../../../config";
import { decryptText, encryptText } from "../../../Utils/OstreonEncryption";
import { useAuth } from "../../../Context/AuthContext";
import { requestOTPsecret } from "../../../Utils/OTP";
import { disableAuthenticator, updateSecret } from "../../../Utils/CustomerUser";
import appsLogo from './styles/img/apps_logo.png'
import { LanguageContext } from "../../../Context/changeLanguageProvider";

const base_url = config.base_url
function Authenticator({ OnClose }) {
    // const customerUser = UserData()?.CustomerUser
    const auth = useAuth()
    const [otpcode, setotpcode] = useState("")
    const [error, setError] = useState()
    const [success, setSuccess] = useState()
    const customerUser = UserData()
    const alert = useAlert()
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [content, setContent] = useState(
        websiteCurrentLang.content.User.MyAccount.Authenticator
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
        setContent(websiteCurrentLang.content.User.MyAccount.Authenticator);
        setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    const authHash = window.sessionStorage.getItem('ostreon_hash')
    // if (!authHash) OnClose()
    const enabled = customerUser?.CustomerUser?.authenticator==='true'
    const [code, setCode] = useState(customerUser?.CustomerUser?.otp_secret)
    const CopyClipboard = (text) => {
        navigator.clipboard.writeText(text.toUpperCase())
        alert.push("Copied", "Code was copied")
    }
    const encrypt_code = async (hash, code) => {
        console.log('No está cifrado')
        const encrypted = await encryptText(hash, code)
        // customerUser.setCustomerUser({...customerUser.CustomerUser, "otp_secret":encrypted})
        updateSecret(encrypted)
            .then(e => {
                customerUser.getCustomerUser()
            })

        // decrypt_code(hash, encrypted)
    }
    const decrypt_code = async (hash, code) => {
        console.log('Está cifrado')
        const decrypted = await decryptText(hash, code)
        const b32_regex = /^[A-Z2-7]+=*$/;
        console.log('ha llegado')
        if (!b32_regex.test(decrypted)){
            console.log('No tiene el formato correcto')
            OnClose()
        }
        else {
            setCode(decrypted)
            console.log('Ha llegadoooo')
        }

    }
    useEffect(() => {
        const aes_pattern = /^[0-9a-fA-F]{16}-[0-9a-fA-F]{24}-[0-9a-fA-F]+$/;
        if (aes_pattern.test(customerUser?.CustomerUser?.otp_secret)) {
            decrypt_code(authHash, customerUser?.CustomerUser.otp_secret)
        }
        else{
            requestOTPsecret()
            .then(code => {
                encrypt_code(authHash, code)
                setCode(code)
            })
            .catch(e => {
                setError('Unable to retrieve a code')
            })
        }
    }, [customerUser?.CustomerUser.otp_secret])
    const handleEnable = () => {
        console.log('ha hecho click')
        if (enabled) {
            console.log('Lo vamos a deshabilitar')
            disableAuthenticator()
                .then(e => {
                    customerUser.getCustomerUser()
                })

            OnClose()
        }
        else {
            if (otpcode === "") {
                setError(content.AuthenticatorError2);
                setTimeout(() => {
                    setError()
                }, 5000);
                return
            }
            if (!code) {
                setError(content.AuthenticatorError3);
                setTimeout(() => {
                    setError()
                }, 5000);
            }
            fetch(base_url + 'user/checkMFA', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials': 'include'
                },
                body: `otp_code=${otpcode}&secret=${code}`,
                credentials: 'include'
            }).then((res) => {
                return res.json()
            }).then(async data => {
                if (data.error === "") {
                    // if (!auth.hash) throw new Error('Unable to encrypt the OTP secret')
                    // const encrypted_secret = encryptText(auth.hash)
                    customerUser.getCustomerUser()
                    // customerUser.setCustomerUser({...customerUser.CustomerUser, "mfa":"Authenticator"})
                    setSuccess(content.AuthenticatorSuccess1);
                    auth.login()
                    setTimeout(() => {
                        OnClose()
                    }, 1000);
                }
                else {
                    setError(data.error)
                    setTimeout(() => {
                        setError()
                    }, 5000);
                }
            }).catch(e => {
                if (e.message === 'Unable to encrypt the OTP secret') setError(dublicatedcontent.dublicatedText78);
                else setError(dublicatedcontent.dublicatedText78);
            })
        }
    }
    const handleEnter = (e) => {
        console.log(e)
        if (e.key === "Enter") {
            handleEnable()
        }
    }
    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.documentElement.style.overflow = "unset";
        };
    }, []);
    return (
        <div className={styles.background} >
            <div onClick={(e) => { e.stopPropagation() }} className={styles.main_box} >
                <div onClick={OnClose} className={styles.close_logo} />
                <div>
                    <div className={styles.title}>{content.AuthenticatorTitle1}</div>
                    <div className={styles.subtitle}>{content.AuthenticatorText3}</div>
                </div>
                {enabled &&
                    <div className={styles.header}>
                        <div className={enabled ? styles.enabled : styles.not_enabled}>
                            <div className={enabled ? styles.enabled_logo : styles.not_enabled_logo} />
                            {enabled ? content.AuthenticatorText4 : content.AuthenticatorText5}
                        </div>
                        <span>{content.AuthenticatorText6}</span>
                        <span>{content.AuthenticatorText7}</span>
                    </div>
                }
                {!enabled &&
                <div className={styles.top_title}>{content.AuthenticatorText8}</div>
                }

                <div className={styles.providers}>
                    {!enabled &&
                        <div className={styles.provider_point}>
                            {content.AuthenticatorText9}
                        </div>
                    }
                    <div className={styles.auth_apps}>
                        <p>
                        {content.AuthenticatorText10}
                        </p>
                        <div className={styles.apps}>
                            <div className={styles.links}>
                                <div className={styles.provider}>
                                    <div className={styles.icon}>
                                        <div className={styles.apple} />
                                    </div>
                                    {content.AuthenticatorText11} <a href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458" target="_blank" className={styles.authy}>Microsoft Authenticator</a>
                                </div>
                                <div className={styles.provider}>
                                    <div className={styles.icon}>
                                        <div className={styles.android} />
                                    </div>
                                    {content.AuthenticatorText13} <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en&gl=US&pli=1" target="_blank" className={styles.authy}>Microsoft Authenticator</a>
                                </div>
                            </div>
                            <div className={styles.logo}>
                                <img src={appsLogo} alt="" />
                            </div>
                        </div>
                        <p>
                        {content.AuthenticatorText14}
                        </p>
                        {enabled &&
                            <div className={styles.rect}></div>
                        }
                    </div>
                    
                    {!enabled &&
                        <div className={styles.provider_point}>
                            {content.AuthenticatorText15}{" "}
                        </div>
                    }

                    <div className={styles.QR_div}>
                        <QRCode
                            size={136}
                            style={{ height: "auto" }}
                            value={`otpauth://totp/OSTREON?secret=${code}`}
                            viewBox={`0 0 256 256`}
                            fgColor="#27313D"
                        />
                    </div>
                    <div onClick={() => CopyClipboard(code)} className={styles.code}>{code}</div>

                    {enabled
                        ? null
                        : (
                            <>  
                                <div className={styles.provider_point}>
                                {content.AuthenticatorText16}{" "}
                                </div>
                                <input onKeyDown={handleEnter} value={otpcode} onChange={(e) => {
                                     const sanitizedValue = e.target.value.replace(/\D/g, '');
                                     if (sanitizedValue.length <= 6) {
                                        setotpcode(sanitizedValue)
                                     }
                                     else return
                                    }} className={`${styles.user_input} ${error ? styles.field_error : ''}`} placeholder="OTP CODE" type="text"></input>
                            </>
                        )}
                    {success ? <div className={styles.success_message}>{success}</div> : null}
                    {error ? <div className={styles.error_message}>{error}</div> : null}
                </div>

                <div className={styles.main_footer}>
                    <div className={styles.footer}>
                        <div onClick={() => handleEnable()} className={`${enabled ? styles.redbutton : styles.bluebutton}`}>{enabled ? content.AuthenticatorText18 : dublicatedcontent.dublicatedText75}</div>
                        <div onClick={OnClose} className={styles.whitebutton}>{content.AuthenticatorText17}</div>
                    </div>
                </div>
            </div>
        </div>
    )

}
export { Authenticator };